import { IExplorableItemTypeInfo, IRecommendationItem } from './resourceInfoParts';

// Client side interface for viz recommendation
export type IViewRecommendationInfo = IExplorableItemTypeInfo<'recommendedView'> & IRecommendationItem;

export const PopularExplanation = 'popular';
export const SimiliarUsersExplanation =  'similar_users';
export const DataMonitoringExplanation = 'data_monitoring_candidate';
